import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { Subscription, combineLatest } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { MktContentStorageService } from "../../../core/services/mkt-content-storage.service";
@Component({
  selector: "app-raf-link-expired",
  standalone: false,
  template: `
    <citi-copy-warning *ngIf="!pageNotFound && !!message">
      <div class="raf-link-wrapper">
        <h1 class="header-4 text-center text-bold">
          <span [innerHtml]="message | safeHtml"></span>
          <a [mktRouterLink]="redirectURL" [attr.alt]="linkText">{{ linkText }}</a
          >.
        </h1>
      </div>
    </citi-copy-warning>
  `,
  styles: [
    `
      :host .raf-link-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 600px;
        font-family: $font-family-bold;
        font-weight: 900;
        flex-direction: row;
      }
      :host ::ng-deep h1.header-4 {
        font-family: $font-family-bold;
        font-size: 1.313rem;
        line-height: 1.688rem;
        font-weight: 400;
      }
    `
  ],
  encapsulation: ViewEncapsulation.Emulated,
})
export class RafLinkExpiredComponent implements OnInit, OnDestroy {
  private category: string = "refer-a-friend-aa-advantage";
  public linkText: string;
  public redirectURL: string;
  public message: string;
  public pageNotFound: Boolean = false;
  private routeSub: Subscription = new Subscription();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _contentStorageService: MktContentStorageService
  ) {}

  ngOnInit() {
    this.routeSub = combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe(params => {
      this.category =
        (!!params[1]["category"] && params[1]["category"]) || this.category;
      this.initilizeComponent();
    });
  }

  private initilizeComponent() {
    console.log("RAFEx: Page load")
    const cardDetailsObj = this._contentStorageService.get(
      "Multi_Product_Page",
      "copy",
      "refer-a-friend-aa-advantage",
      undefined
    );
    // Try to get card categories
    if (!!cardDetailsObj.expirePageContent) {
        const expirePageContent = JSON.parse(cardDetailsObj.expirePageContent || '{}');
        this.linkText = expirePageContent.linkText;
        this.redirectURL = expirePageContent.redirectURL;
        this.message = expirePageContent.message;
        console.log("RAFEx: Content Found");
    }else {
        console.log("RAFEx: No Content Found");
        this.router.navigateByUrl('page-not-found');
    }
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }
}
